export function findLastNumber(inputString: string, type: 'ru' | 'en'): string {
  const numbers = inputString.match(/\d+/g);
  const x = numbers && numbers.length > 0
    ? parseInt(numbers[numbers.length - 1], 10)
    : 0;
  if (type === 'en') {
    return getEnglishDayForm(x)
  } else {
    return getRussianDayForm(x)
  }
}

function getRussianDayForm(number: number): string {
  if (number % 10 === 1 && number % 100 !== 11) {
    return `${number} день`;
  } else if ([2, 3, 4].includes(number % 10) && ![12, 13, 14].includes(number % 100)) {
    return `${number} дня`;
  } else {
    return `${number} дней`;
  }
}

function getEnglishDayForm(number: number): string {
  return number === 1 ? `${number} day` : `${number} days`;
}
